
const DashboardCard = ({ card, isSelected, onClick }) => {
  return (
    <div
      className={`
        relative p-6 rounded-xl cursor-pointer transition-all duration-300 shadow-sm border-2
        ${isSelected 
          ? `${card.bgColor} border-current ${card.color} shadow-md` 
          : `bg-white border-gray-200 ${card.hoverColor} hover:shadow-md`
        }
      `}
      onClick={onClick}
    >
      <div className="flex flex-col items-center text-center">
        <div className={`text-3xl font-bold mb-2 ${isSelected ? card.color : 'text-gray-800'}`}>
          {card.value}
        </div>
        <div className={`text-sm font-medium ${isSelected ? card.color : 'text-gray-600'}`}>
          {card.title}
        </div>
      </div>
      
      {isSelected && (
        <div className="absolute top-2 right-2">
          <div className={`w-3 h-3 rounded-full ${card.color.replace('text-', 'bg-')}`}></div>
        </div>
      )}
    </div>
  );
};

export default DashboardCard;